<template>
  <vx-card >

    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onClickUpdate)" autocomplete="off">

        <div class="vx-row mb-3" v-if="form.raw_material_stage">
          <div class="vx-col w-full">
            <vs-chip style="border-radius: 5px" class="float-right mb-8" transparent color="dark">
              STAGE: {{form.raw_material_stage}}
            </vs-chip>
            <vs-chip style="border-radius: 5px" class="float-right" transparent v-if="status.status" :color="statusColorFactory(status.status ? status.status.id : '')">
              STATUS: {{status.status ? status.status.name : ''}}
            </vs-chip>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 w-full md:mb-0">
<!--            <ValidationProvider vid="company_product_code" name="company_product_code" rules="" v-slot="{ errors }">-->
<!--              <small class="label">ITS Product Code</small>-->
<!--              <vs-input :disabled="__isDisabledRawMaterial(status)" disabled v-model="form.category.prefix + '-' +form.company_product_code" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" name="company_product_code" class="w-full" label=""/>-->
<!--            </ValidationProvider>-->
            <vs-alert color="dark" active="false">
              <small>ITS product code: &nbsp;&nbsp;</small> {{form.company_product_code ? form.category.prefix + '-' +form.company_product_code : ''}}
            </vs-alert>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
<!--            <ValidationProvider vid="company_product_name" name="company_product_name" rules="" v-slot="{ errors }">-->
<!--              <small class="label">ITS Product Name</small>-->
<!--              <vs-input :disabled="__isDisabledRawMaterial(status)" disabled  v-model="form.company_product_name" name="company_product_name"  class="w-full required" label=""  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>-->
<!--            </ValidationProvider>-->
            <vs-alert color="dark" active="false">
              <small>ITS Product Name: &nbsp;&nbsp;</small> {{form.company_product_name}}
            </vs-alert>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <!--            <ValidationProvider vid="supplier_product_code" name="supplier_product_code" rules="required" v-slot="{ errors }">-->
            <!--              <small class="label">Supplier Product Code</small>-->
            <!--              <vs-input :disabled="__isDisabledRawMaterial(status)" v-model="form.supplier_product_code" name="supplier_product_code"  class="w-full required" label=""  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>-->

            <!--            </ValidationProvider>-->
            <vs-alert color="dark" active="false">
              <small>Supplier Product Code: &nbsp;&nbsp;</small> {{form.supplier_product_code}}
            </vs-alert>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <!--            <ValidationProvider vid="supplier_product_name" name="supplier_product_name" rules="" v-slot="{ errors }">-->
            <!--              <small class="label">Supplier Product Name</small>-->
            <!--              <vs-input :disabled="__isDisabledRawMaterial(status)" name="supplier_product_name" v-model="form.supplier_product_name"  class="w-full required" label=""  :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>-->

            <!--            </ValidationProvider>-->
            <vs-alert color="dark" active="false">
              <small>Supplier Product Name: &nbsp;&nbsp;</small> {{form.supplier_product_name}}
            </vs-alert>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="alternative_chemical_name" name="alternative_chemical_name" rules="" v-slot="{ errors }">
              <small class="label">Alternative / Chemical Name</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" name="alternative_chemical_name" v-model="form.alternative_chemical_name"  class="w-full required" label="" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full">
            <ValidationProvider vid="country_processing" name="country_processing" rules="required" v-slot="{ errors }">
              <small class="label">Country of Processing</small>
              <v-select multiple :disabled="__isDisabledRawMaterial(status)" :filter-by="myFilter"  :clearable="false" name="country_processing" placeholder="" label="name" v-model="form.country_processing" :reduce="option => option.id" :options="countryCodes" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                <template v-slot:option="option">
                  <span>{{option.name}} </span>
                </template>
              </v-select>
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/2 w-full md:mb-0" v-if="form.country_processing === 'China'">
            <ValidationProvider  vid="china_province" name="china_province" rules="" v-slot="{ errors }">
              <small class="label">If China, please state Province?</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" name="china_province" v-model="form.china_province"  class="w-full required" label="" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-1/2 w-full md:mb-0">
            <ValidationProvider vid="manufacturing_site" name="manufacturing_site" rules="required" v-slot="{ errors }">
              <small class="label">Manufacturing Sites</small>
              <v-select multiple :disabled="__isDisabledRawMaterial(status)" :clearable="false" name="manufacturing_site" placeholder="" label="site_name" v-model="form.manufacturing_site" :reduce="option => option.id" :options="sites" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                <template v-slot:option="option">
                  <span>{{option.site_name}} </span>
                </template>
              </v-select>
              <span class="text-danger text-sm">{{ errors[0] }}</span>
            </ValidationProvider>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/3 md:mb-0">
            <ValidationProvider vid="is_food_grade" name="is_food_grade" rules="" v-slot="{ errors }">
              <small class="label">Food Grade?</small>
              <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="form.is_food_grade" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-2/3 w-full md:mb-0">
            <ValidationProvider v-if="form.is_food_grade" vid="is_food_grade_comment" name="is_food_grade_comment" rules="" v-slot="{ errors }">
              <small class="label">If yes,please specify</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" name="is_food_grade_comment" class="w-full" v-model="form.is_food_grade_comment" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col md:w-1/3 md:mb-0">
            <ValidationProvider vid="is_compliant_food_law" name="is_compliant_food_law" rules="" v-slot="{ errors }">
              <small class="label">Compliant with General Food Law (Regulation (EC) No 178/2002)</small>
              <vs-switch :disabled="__isDisabledRawMaterial(status)" v-model="form.is_compliant_food_law" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
          <div class="vx-col md:w-2/3 w-full md:mb-0">
            <ValidationProvider v-if="form.is_compliant_food_law" vid="is_compliant_food_law_comment" name="is_compliant_food_law_comment" rules="" v-slot="{ errors }">
              <small class="label">If yes,please specify</small>
              <vs-input :disabled="__isDisabledRawMaterial(status)" type="text" name="is_compliant_food_law_comment" class="w-full" v-model="form.is_compliant_food_law_comment" :danger="errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
            </ValidationProvider>
          </div>
        </div>
        <div class="vx-row mb-3">
          <div class="vx-col w-full">
            <small class="label">Additional Information</small>
            <vs-textarea :disabled="__isDisabledRawMaterial(status)" v-model="form.additional_information" />
          </div>
        </div>
        <div class="flex flex-wrap items-center justify-end">
          <vs-button button="submit" class="ml-auto mt-2" :disabled="__isDisabledRawMaterial(status)">Save Changes</vs-button>
          <!--          <vs-button class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>-->
        </div>
      </form>
    </ValidationObserver>
  </vx-card>

</template>

<script>
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  const SupplierRawMaterialRepository = RepositoryFactory.get('supplierRawMaterial')
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import vSelect from 'vue-select'

  export default {
    name: "SupplierManufacturingHome",
    components: {
      'v-select': vSelect
    },
    data() {
      return {
        form: {
          is_food_grade: false,
          is_compliant_food_law: false
        },
        id: null,
        countryCodes: [],
        site_ids: [],
        site_names: [],
        status: {},
        supplierId: '',
        sites: [],
      }
    },
    mixins: [SuccessMessage, ErrorMessages],
    methods: {
      async onClickNext() {
        this.$emit('notify', 1)
      },
      async onClickUpdate() {
        this.$vs.loading()
        try {
          const data = (await SupplierRawMaterialRepository.updateRawMaterialDetails(this.id, this.form))
          this.showSuccessMessage('Raw Material Details Updated!')
          this.onClickNext()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async loadCountrCode() {
        const {data} =  (await SupplierManufactureRepository.getCountryCodes()).data
        this.countryCodes =  data
      },
      statusColorFactory(id) {
        switch (id) {
          case 1:
            return 'danger'
          case 2:
            return 'warning'
          case 3:
            return 'success'
          default:
            return 'danger'
        }
      },
      myFilter: (option, label, search) => {
        let temp = search.toLowerCase();
        return option.name.toLowerCase().indexOf(temp) > -1 ||
          option.isd_code.toLowerCase().indexOf(temp) > -1
      },
      async loadManufacturingSites() {
        this.$vs.loading()
        try {
          const {data} = await SupplierManufactureRepository.getAllManufacturerSites(this.supplierId, this.page, this.filterQuery, 100, this.sort)
          this.sites =  data.data
          this.meta = data.meta
        } catch (e) {

        }
        this.$vs.loading.close()
      },
    },
    async mounted() {
      this.$vs.loading()
      this.id = this.$route.params.id
      this.supplierId = this.$route.params.supplierId

      const {data} = (await SupplierRawMaterialRepository.getRawMaterialDetails(this.id)).data
      this.form = data

      const status = (await SupplierRawMaterialRepository.getRawMaterialStatus(this.id)).data
      await this.loadCountrCode()
      await this.loadManufacturingSites()
      this.status = status.data
      this.form.manufacturing_site = this.form.manufacturing_site.map((m) => m.id)
      this.form.country_processing = this.form.country_processing.map((m) => m.id)
      this.site_names = this.form.manufacturing_site.map((m) => m.site_name)

      this.$vs.loading.close()
    }

  }
</script>

<style scoped>

</style>
